var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 52,
    viewBox: "0 0 145 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8354 37.2897C22.0181 40.6366 21.1241 44.9305 21.4848 48.6C20.1509 47.7935 19.6128 46.5846 17.6022 45.2484C12.3119 41.7336 7.62217 40.6491 1.12896 39.8867L1.04503 20.6231C9.70901 20.9653 18.0974 29.5394 20.8348 37.2897H20.8354ZM42.3239 20.5005C42.2941 23.714 42.7072 37.9903 42.1775 39.7777C39.7918 40.6009 36.4557 40.1271 30.5833 42.8372C28.9256 43.602 27.1578 44.5663 25.8608 45.5263L23.824 47.1935C23.3752 47.5519 23.2341 47.6644 22.8514 48.0715C22.23 48.7334 22.2901 48.759 21.6586 48.8536C22.5639 42.5747 20.0122 39.8474 24.3359 32.4631C27.8661 26.4336 35.2265 20.6737 42.3245 20.5005H42.3239ZM10.7512 22.4665C8.68583 22.304 7.95966 19.3928 8.06026 17.2476C8.29298 12.2811 12.9125 10.2502 17.0956 11.7639C19.4217 12.6055 20.0902 13.6561 21.4949 15.0382L22.5383 13.9674C25.3519 11.1222 29.447 10.4217 32.3368 12.3805C34.9623 14.1602 35.7587 21.7195 31.5975 22.8117C31.9165 21.2004 33.451 20.0618 33.501 17.4607C33.5403 15.3887 32.1278 13.6864 30.8106 13.0882C25.6674 10.7532 22.2205 16.5577 21.4955 17.2208C21.008 16.9542 21.011 16.8434 20.5955 16.2976C15.4314 9.5086 9.52568 13.4591 9.20426 17.0934C9.10546 18.2148 9.30902 19.0547 9.65246 20.0392C9.99471 21.0213 10.5447 21.7171 10.7512 22.4665ZM11.6066 9.94013C13.5357 6.44561 23.1555 4.06296 29.2583 8.24079C30.5892 9.15206 30.7749 9.0723 30.982 9.90799C24.0942 8.61815 23.096 11.7407 21.2895 12.4918C18.4117 9.74728 16.107 9.06992 11.6072 9.94013H11.6066ZM36.1063 20.6106C36.558 17.5262 37.039 16.5316 35.8902 13.362C31.4564 1.13152 11.8524 0.0887012 6.59959 13.6763C5.47285 16.5911 5.89129 17.9476 6.45377 20.7499C4.43955 20.0999 2.29915 19.5469 -0.000167847 19.5303L0.00221353 41.0116C4.60145 41.092 9.77269 42.3681 13.4154 44.0788C21.6479 47.9447 20.0711 50.4172 21.9074 51.9999C22.8085 51.188 22.6556 49.7702 25.3674 47.2953C29.7101 43.3318 37.2729 41.1973 43.5364 40.864L43.5203 19.4576C40.5049 19.4886 38.8419 20.1332 36.1063 20.6106Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7302 14.6585C68.3385 16.2823 68.5921 22.6011 68.6183 24.6713C68.6635 28.1831 69.007 30.2193 70.6111 32.8436C72.7556 36.35 77.3316 37.791 81.3767 36.5179C83.1445 35.9613 83.5558 35.2768 84.8849 34.7685C84.8344 37.1309 84.2766 37.2839 86.5944 37.2756C88.5497 37.2684 88.7622 37.5166 90.2496 36.7875C90.621 34.7739 90.6199 15.9734 90.1746 14.7294C88.6503 14.1871 85.1254 14.1609 84.4201 15.671C84.0796 16.4001 84.2409 21.0083 84.2403 22.1993C84.2385 25.1599 85.2266 31.4883 79.3899 31.4038C71.9247 31.2954 76.0954 18.2828 74.6603 15.3788C74.0044 14.052 70.3742 14.3342 68.7302 14.6591V14.6585Z",
    fill: "#4F46E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2678 37.2774C61.0714 33.0466 59.0839 27.5241 61.3743 23.7659L68.4181 12.6794C68.9282 11.9116 69.4455 10.8539 68.7318 9.98668C68.2193 9.36468 64.1254 8.5903 62.9844 10.3152L58.1232 18.2144C58.0477 18.3471 57.9096 18.5995 57.7941 18.7316C57.409 19.1727 57.7983 18.8715 57.1774 19.2465C56.6251 17.759 55.1745 15.6895 54.2781 14.1217C53.5389 12.8294 51.9128 9.70038 50.939 9.44027C50.2116 9.24564 47.5861 9.23492 46.857 9.42599C43.6696 10.2629 47.7248 15.1222 48.8974 16.871C49.9563 18.4495 50.9521 20.1518 51.9794 21.8017C53.5133 24.2653 53.9811 24.2475 54.0067 27.7599C54.0585 34.8411 52.8318 37.2934 56.512 37.2768C57.7655 37.2708 59.0149 37.2672 60.2684 37.2762L60.2678 37.2774Z",
    fill: "#4F46E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.249 6.89928C93.6304 5.59813 94.437 8.02126 94.4459 11.4842C94.4554 15.0555 94.4608 18.6274 94.4417 22.1981C94.3501 39.5915 93.3061 37.4595 100.602 37.2547C100.45 32.1537 100.547 26.9021 100.54 21.7862C100.536 19.0244 100.837 8.64862 100.249 6.89868V6.89928Z",
    fill: "#4F46E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.892 37.2287C110.849 35.2579 110.993 16.2979 110.762 15.5223C110.448 14.4682 109.333 14.4616 108.033 14.4587C103.319 14.448 104.617 14.8843 104.601 29.2034C104.593 36.3418 103.812 37.309 107.411 37.2924C108.576 37.287 109.727 37.29 110.892 37.2281V37.2287Z",
    fill: "#4F46E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6066 9.9394C16.1071 9.06919 18.4112 9.74655 21.289 12.4911C23.0955 11.7399 24.0937 8.61742 30.9815 9.90726C30.775 9.07157 30.5887 9.15133 29.2578 8.24005C23.1556 4.06163 13.5351 6.44488 11.606 9.9394H11.6066Z",
    fill: "#7C459C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7518 22.4668C10.5453 21.7174 9.99528 21.0216 9.65303 20.0395C9.30959 19.055 9.10603 18.2151 9.20483 17.0937C9.52565 13.4593 15.432 9.5083 20.5961 16.2979C21.0115 16.8437 21.0086 16.9545 21.4961 17.2211C22.2204 16.558 25.6679 10.7535 30.8112 13.0885C32.1284 13.6867 33.5409 15.389 33.5016 17.461C33.4522 20.0621 31.9171 21.2007 31.5981 22.812C35.7592 21.7198 34.9628 14.1611 32.3373 12.3808C29.4476 10.422 25.3525 11.1225 22.5389 13.9677L21.4955 15.0385C20.0907 13.6564 19.4223 12.6064 17.0962 11.7642C12.913 10.2505 8.29355 12.2814 8.06082 17.2479C7.96023 19.3931 8.6864 22.3043 10.7518 22.4668Z",
    fill: "#6C3695"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2582_57976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 20,
    width: 21,
    height: 29
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8355 37.2897C18.0981 29.5394 9.70969 20.9653 1.04572 20.623L1.12965 39.8866C7.62287 40.6491 12.312 41.7336 17.6029 45.2483C19.6135 46.5846 20.151 47.7935 21.4855 48.6C21.1242 44.9305 22.0182 40.6366 20.8361 37.2897H20.8355Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2582_57976)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04572 20.623H1.0856V48.6H1.04572V20.623Z",
    fill: "#44018E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04572 20.623H1.16536V48.6H1.04572V20.623Z",
    fill: "#3D008C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12528 20.623H1.24492V48.6H1.12528V20.623Z",
    fill: "#3D008C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20502 20.623H1.32525V48.6H1.20502V20.623Z",
    fill: "#3E008D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28475 20.623H1.40498V48.6H1.28475V20.623Z",
    fill: "#3E008D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3652 20.623H1.48484V48.6H1.3652V20.623Z",
    fill: "#3F008E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44494 20.623H1.56458V48.6H1.44494V20.623Z",
    fill: "#3F008E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.52467 20.623H1.64431V48.6H1.52467V20.623Z",
    fill: "#3F008F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60441 20.623H1.72405V48.6H1.60441V20.623Z",
    fill: "#40008F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.68414 20.623H1.80438V48.6H1.68414V20.623Z",
    fill: "#400090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76405 20.623H1.88429V48.6H1.76405V20.623Z",
    fill: "#410090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.84433 20.623H1.96397V48.6H1.84433V20.623Z",
    fill: "#410091"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92406 20.623H2.0437V48.6H1.92406V20.623Z",
    fill: "#410091"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0038 20.623H2.12344V48.6H2.0038V20.623Z",
    fill: "#420092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08353 20.623H2.20317V48.6H2.08353V20.623Z",
    fill: "#420092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16344 20.623H2.28308V48.6H2.16344V20.623Z",
    fill: "#420093"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.24318 20.623H2.36282V48.6H2.24318V20.623Z",
    fill: "#430093"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32291 20.623H2.44315V48.6H2.32291V20.623Z",
    fill: "#430094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40318 20.623H2.52282V48.6H2.40318V20.623Z",
    fill: "#440094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48292 20.623H2.60256V48.6H2.48292V20.623Z",
    fill: "#440095"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56284 20.623H2.68247V48.6H2.56284V20.623Z",
    fill: "#440095"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.64257 20.623H2.76221V48.6H2.64257V20.623Z",
    fill: "#450096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72231 20.623H2.84194V48.6H2.72231V20.623Z",
    fill: "#450096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80204 20.623H2.92168V48.6H2.80204V20.623Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88177 20.623H3.00141V48.6H2.88177V20.623Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96151 20.623H3.08174V48.6H2.96151V20.623Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04196 20.623H3.1616V48.6H3.04196V20.623Z",
    fill: "#470098"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1217 20.623H3.24134V48.6H3.1217V20.623Z",
    fill: "#470098"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20143 20.623H3.32107V48.6H3.20143V20.623Z",
    fill: "#480099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28117 20.623H3.40081V48.6H3.28117V20.623Z",
    fill: "#480099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3609 20.623H3.48054V48.6H3.3609V20.623Z",
    fill: "#48009A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44064 20.623H3.56027V48.6H3.44064V20.623Z",
    fill: "#49009A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52055 20.623H3.64078V48.6H3.52055V20.623Z",
    fill: "#49009B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60082 20.623H3.72046V48.6H3.60082V20.623Z",
    fill: "#4A009B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68056 20.623H3.80019V48.6H3.68056V20.623Z",
    fill: "#4A009C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.76029 20.623H3.87993V48.6H3.76029V20.623Z",
    fill: "#4A009C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84003 20.623H3.95966V48.6H3.84003V20.623Z",
    fill: "#4B009D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91994 20.623H4.03958V48.6H3.91994V20.623Z",
    fill: "#4B009D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99967 20.623H4.11991V48.6H3.99967V20.623Z",
    fill: "#4C009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07941 20.623H4.19964V48.6H4.07941V20.623Z",
    fill: "#4C009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15968 20.623H4.27931V48.6H4.15968V20.623Z",
    fill: "#4C009F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23941 20.623H4.35905V48.6H4.23941V20.623Z",
    fill: "#4D009F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31915 20.623H4.43878V48.6H4.31915V20.623Z",
    fill: "#4D00A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39906 20.623H4.5187V48.6H4.39906V20.623Z",
    fill: "#4D00A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4788 20.623H4.59844V48.6H4.4788V20.623Z",
    fill: "#4E00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55853 20.623H4.67817V48.6H4.55853V20.623Z",
    fill: "#4E00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63827 20.623H4.7585V48.6H4.63827V20.623Z",
    fill: "#4F00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.718 20.623H4.83824V48.6H4.718V20.623Z",
    fill: "#4F00A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79845 20.623H4.91809V48.6H4.79845V20.623Z",
    fill: "#4F00A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87819 20.623H4.99783V48.6H4.87819V20.623Z",
    fill: "#5000A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95792 20.623H5.07756V48.6H4.95792V20.623Z",
    fill: "#5000A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03766 20.623H5.1573V48.6H5.03766V20.623Z",
    fill: "#5100A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11739 20.623H5.23703V48.6H5.11739V20.623Z",
    fill: "#5100A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19713 20.623H5.31677V48.6H5.19713V20.623Z",
    fill: "#5100A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27686 20.623H5.39709V48.6H5.27686V20.623Z",
    fill: "#5200A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35677 20.623H5.47701V48.6H5.35677V20.623Z",
    fill: "#5200A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43705 20.623H5.55669V48.6H5.43705V20.623Z",
    fill: "#5300A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51678 20.623H5.63642V48.6H5.51678V20.623Z",
    fill: "#5300A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59651 20.623H5.71615V48.6H5.59651V20.623Z",
    fill: "#5300A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67625 20.623H5.79588V48.6H5.67625V20.623Z",
    fill: "#5400A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75616 20.623H5.8764V48.6H5.75616V20.623Z",
    fill: "#5400A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8359 20.623H5.95613V48.6H5.8359V20.623Z",
    fill: "#5500A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91617 20.623H6.03581V48.6H5.91617V20.623Z",
    fill: "#5500A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9959 20.623H6.11554V48.6H5.9959V20.623Z",
    fill: "#5500AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07564 20.623H6.19528V48.6H6.07564V20.623Z",
    fill: "#5600AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15556 20.623H6.27519V48.6H6.15556V20.623Z",
    fill: "#5600AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.23529 20.623H6.35493V48.6H6.23529V20.623Z",
    fill: "#5600AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31503 20.623H6.43526V48.6H6.31503V20.623Z",
    fill: "#5700AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39476 20.623H6.515V48.6H6.39476V20.623Z",
    fill: "#5700AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47503 20.623H6.59467V48.6H6.47503V20.623Z",
    fill: "#5800AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55495 20.623H6.67459V48.6H6.55495V20.623Z",
    fill: "#5800AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63468 20.623H6.75432V48.6H6.63468V20.623Z",
    fill: "#5800AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71442 20.623H6.83405V48.6H6.71442V20.623Z",
    fill: "#5900AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79415 20.623H6.91379V48.6H6.79415V20.623Z",
    fill: "#5900AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87389 20.623H6.99352V48.6H6.87389V20.623Z",
    fill: "#5A00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95362 20.623H7.07385V48.6H6.95362V20.623Z",
    fill: "#5A00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03336 20.623H7.15359V48.6H7.03336V20.623Z",
    fill: "#5A00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11381 20.623H7.23344V48.6H7.11381V20.623Z",
    fill: "#5B00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19354 20.623H7.31318V48.6H7.19354V20.623Z",
    fill: "#5B00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27327 20.623H7.39291V48.6H7.27327V20.623Z",
    fill: "#5C00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35301 20.623H7.47265V48.6H7.35301V20.623Z",
    fill: "#5C00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43274 20.623H7.55238V48.6H7.43274V20.623Z",
    fill: "#5C00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51266 20.623H7.6323V48.6H7.51266V20.623Z",
    fill: "#5D00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59239 20.623H7.71263V48.6H7.59239V20.623Z",
    fill: "#5D00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67213 20.623H7.79236V48.6H7.67213V20.623Z",
    fill: "#5E00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7524 20.623H7.87203V48.6H7.7524V20.623Z",
    fill: "#5E00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83213 20.623H7.95177V48.6H7.83213V20.623Z",
    fill: "#5E00B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91205 20.623H8.03169V48.6H7.91205V20.623Z",
    fill: "#5F00B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99178 20.623H8.11142V48.6H7.99178V20.623Z",
    fill: "#5F00B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07152 20.623H8.19175V48.6H8.07152V20.623Z",
    fill: "#6000B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15125 20.623H8.27149V48.6H8.15125V20.623Z",
    fill: "#6000B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23152 20.623H8.35116V48.6H8.23152V20.623Z",
    fill: "#6000B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31144 20.623H8.43108V48.6H8.31144V20.623Z",
    fill: "#6100B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39117 20.623H8.51081V48.6H8.39117V20.623Z",
    fill: "#6100B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.47091 20.623H8.59055V48.6H8.47091V20.623Z",
    fill: "#6100B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55064 20.623H8.67028V48.6H8.55064V20.623Z",
    fill: "#6200B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63038 20.623H8.75061V48.6H8.63038V20.623Z",
    fill: "#6200B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71011 20.623H8.83035V48.6H8.71011V20.623Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79057 20.623H8.9102V48.6H8.79057V20.623Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8703 20.623H8.98994V48.6H8.8703V20.623Z",
    fill: "#6300BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95004 20.623H9.06967V48.6H8.95004V20.623Z",
    fill: "#6400BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02977 20.623H9.14941V48.6H9.02977V20.623Z",
    fill: "#6400BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1095 20.623H9.22914V48.6H9.1095V20.623Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18923 20.623H9.30887V48.6H9.18923V20.623Z",
    fill: "#6500BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26897 20.623H9.3892V48.6H9.26897V20.623Z",
    fill: "#6500BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34888 20.623H9.46912V48.6H9.34888V20.623Z",
    fill: "#6600BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42915 20.623H9.54879V48.6H9.42915V20.623Z",
    fill: "#6600BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50889 20.623H9.62853V48.6H9.50889V20.623Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58862 20.623H9.70826V48.6H9.58862V20.623Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66836 20.623H9.788V48.6H9.66836V20.623Z",
    fill: "#6700C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74828 20.623H9.86791V48.6H9.74828V20.623Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82801 20.623H9.94765V48.6H9.82801V20.623Z",
    fill: "#6800C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90775 20.623H10.028V48.6H9.90775V20.623Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98801 20.623H10.1077V48.6H9.98801V20.623Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0677 20.623H10.1874V48.6H10.0677V20.623Z",
    fill: "#6900C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1477 20.623H10.2673V48.6H10.1477V20.623Z",
    fill: "#6A00C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2274 20.623H10.347V48.6H10.2274V20.623Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3071 20.623H10.4268V48.6H10.3071V20.623Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3869 20.623H10.5071V48.6H10.3869V20.623Z",
    fill: "#6B00C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4671 20.623H10.5868V48.6H10.4671V20.623Z",
    fill: "#6B00C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5471 20.623H10.6667V48.6H10.5471V20.623Z",
    fill: "#6B00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6268 20.623H10.7464V48.6H10.6268V20.623Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7065 20.623H10.8262V48.6H10.7065V20.623Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7863 20.623H10.9059V48.6H10.7863V20.623Z",
    fill: "#6A00C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.866 20.623H10.9856V48.6H10.866V20.623Z",
    fill: "#6900C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9457 20.623H11.0654V48.6H10.9457V20.623Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0255 20.623H11.1457V48.6H11.0255V20.623Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1059 20.623H11.2255V48.6H11.1059V20.623Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1856 20.623H11.3053V48.6H11.1856V20.623Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2654 20.623H11.385V48.6H11.2654V20.623Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3451 20.623H11.4648V48.6H11.3451V20.623Z",
    fill: "#6800BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4249 20.623H11.5445V48.6H11.4249V20.623Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5048 20.623H11.6244V48.6H11.5048V20.623Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5845 20.623H11.7041V48.6H11.5845V20.623Z",
    fill: "#6700BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6642 20.623H11.7845V48.6H11.6642V20.623Z",
    fill: "#6700BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7445 20.623H11.8641V48.6H11.7445V20.623Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8242 20.623H11.9439V48.6H11.8242V20.623Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9042 20.623H12.0238V48.6H11.9042V20.623Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9839 20.623H12.1035V48.6H11.9839V20.623Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0636 20.623H12.1833V48.6H12.0636V20.623Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1434 20.623H12.2636V48.6H12.1434V20.623Z",
    fill: "#6500BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2231 20.623H12.3433V48.6H12.2231V20.623Z",
    fill: "#6500BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3036 20.623H12.4232V48.6H12.3036V20.623Z",
    fill: "#6400BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3833 20.623H12.5029V48.6H12.3833V20.623Z",
    fill: "#6400BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.463 20.623H12.5827V48.6H12.463V20.623Z",
    fill: "#6400BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5428 20.623H12.6624V48.6H12.5428V20.623Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6225 20.623H12.7421V48.6H12.6225V20.623Z",
    fill: "#6300B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7022 20.623H12.8225V48.6H12.7022V20.623Z",
    fill: "#6300B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7827 20.623H12.9023V48.6H12.7827V20.623Z",
    fill: "#6300B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8624 20.623H12.9821V48.6H12.8624V20.623Z",
    fill: "#6200B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9421 20.623H13.0618V48.6H12.9421V20.623Z",
    fill: "#6200B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0219 20.623H13.1415V48.6H13.0219V20.623Z",
    fill: "#6200B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1016 20.623H13.2212V48.6H13.1016V20.623Z",
    fill: "#6100B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1813 20.623H13.301V48.6H13.1813V20.623Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2613 20.623H13.3809V48.6H13.2613V20.623Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.341 20.623H13.4612V48.6H13.341V20.623Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4213 20.623H13.5409V48.6H13.4213V20.623Z",
    fill: "#6000B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.501 20.623H13.6206V48.6H13.501V20.623Z",
    fill: "#6000B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5807 20.623H13.7004V48.6H13.5807V20.623Z",
    fill: "#6000B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6607 20.623H13.7803V48.6H13.6607V20.623Z",
    fill: "#5F00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7404 20.623H13.86V48.6H13.7404V20.623Z",
    fill: "#5F00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8201 20.623H13.9398V48.6H13.8201V20.623Z",
    fill: "#5F00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8999 20.623H14.0195V48.6H13.8999V20.623Z",
    fill: "#5F00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9796 20.623H14.0998V48.6H13.9796V20.623Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.06 20.623H14.1797V48.6H14.06V20.623Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1398 20.623H14.2594V48.6H14.1398V20.623Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2195 20.623H14.3392V48.6H14.2195V20.623Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2992 20.623H14.4189V48.6H14.2992V20.623Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.379 20.623H14.4986V48.6H14.379V20.623Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4587 20.623H14.5789V48.6H14.4587V20.623Z",
    fill: "#5D00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5392 20.623H14.6588V48.6H14.5392V20.623Z",
    fill: "#5C00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6189 20.623H14.7385V48.6H14.6189V20.623Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6986 20.623H14.8183V48.6H14.6986V20.623Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7784 20.623H14.898V48.6H14.7784V20.623Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8581 20.623H14.9777V48.6H14.8581V20.623Z",
    fill: "#5B00AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9378 20.623H15.0575V48.6H14.9378V20.623Z",
    fill: "#5B00AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0176 20.623H15.1378V48.6H15.0176V20.623Z",
    fill: "#5B00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.098 20.623H15.2177V48.6H15.098V20.623Z",
    fill: "#5A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1778 20.623H15.2974V48.6H15.1778V20.623Z",
    fill: "#5A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2575 20.623H15.3771V48.6H15.2575V20.623Z",
    fill: "#5A00AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3372 20.623H15.4569V48.6H15.3372V20.623Z",
    fill: "#5A00AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.417 20.623H15.5366V48.6H15.417V20.623Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4969 20.623H15.6165V48.6H15.4969V20.623Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5766 20.623H15.6962V48.6H15.5766V20.623Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6563 20.623H15.7766V48.6H15.6563V20.623Z",
    fill: "#5800AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7366 20.623H15.8563V48.6H15.7366V20.623Z",
    fill: "#5800AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8164 20.623H15.936V48.6H15.8164V20.623Z",
    fill: "#5800A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8963 20.623H16.0159V48.6H15.8963V20.623Z",
    fill: "#5800A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.976 20.623H16.0956V48.6H15.976V20.623Z",
    fill: "#5701A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0557 20.623H16.1754V48.6H16.0557V20.623Z",
    fill: "#5701A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1355 20.623H16.2551V48.6H16.1355V20.623Z",
    fill: "#5701A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2152 20.623H16.3354V48.6H16.2152V20.623Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2949 20.623H16.4152V48.6H16.2949V20.623Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3754 20.623H16.495V48.6H16.3754V20.623Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4551 20.623H16.5748V48.6H16.4551V20.623Z",
    fill: "#5601A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5349 20.623H16.6545V48.6H16.5349V20.623Z",
    fill: "#5501A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6146 20.623H16.7342V48.6H16.6146V20.623Z",
    fill: "#5501A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6943 20.623H16.8146V48.6H16.6943V20.623Z",
    fill: "#5501A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7741 20.623H16.8943V48.6H16.7741V20.623Z",
    fill: "#5401A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8545 20.623H16.9742V48.6H16.8545V20.623Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9342 20.623H17.0539V48.6H16.9342V20.623Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.014 20.623H17.1336V48.6H17.014V20.623Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0937 20.623H17.2134V48.6H17.0937V20.623Z",
    fill: "#5301A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1735 20.623H17.2931V48.6H17.1735V20.623Z",
    fill: "#5301A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2534 20.623H17.373V48.6H17.2534V20.623Z",
    fill: "#5301A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3331 20.623H17.4533V48.6H17.3331V20.623Z",
    fill: "#5201A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4128 20.623H17.5331V48.6H17.4128V20.623Z",
    fill: "#5201A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4931 20.623H17.6127V48.6H17.4931V20.623Z",
    fill: "#5201A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5728 20.623H17.6925V48.6H17.5728V20.623Z",
    fill: "#5201A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6528 20.623H17.7724V48.6H17.6528V20.623Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7325 20.623H17.8521V48.6H17.7325V20.623Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8122 20.623H17.9319V48.6H17.8122V20.623Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.892 20.623H18.0116V48.6H17.892V20.623Z",
    fill: "#50019F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9717 20.623H18.0919V48.6H17.9717V20.623Z",
    fill: "#50019F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0514 20.623H18.1717V48.6H18.0514V20.623Z",
    fill: "#50019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1319 20.623H18.2515V48.6H18.1319V20.623Z",
    fill: "#50019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2116 20.623H18.3313V48.6H18.2116V20.623Z",
    fill: "#4F019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2914 20.623H18.411V48.6H18.2914V20.623Z",
    fill: "#4F019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3711 20.623H18.4907V48.6H18.3711V20.623Z",
    fill: "#4F019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4508 20.623H18.5705V48.6H18.4508V20.623Z",
    fill: "#4E019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5306 20.623H18.6508V48.6H18.5306V20.623Z",
    fill: "#4E019C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6105 20.623H18.7307V48.6H18.6105V20.623Z",
    fill: "#4E019C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6907 20.623H18.8104V48.6H18.6907V20.623Z",
    fill: "#4E019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7705 20.623H18.8901V48.6H18.7705V20.623Z",
    fill: "#4D019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8502 20.623H18.9698V48.6H18.8502V20.623Z",
    fill: "#4D019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9299 20.623H19.0496V48.6H18.9299V20.623Z",
    fill: "#4D019A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0099 20.623H19.1301V48.6H19.0099V20.623Z",
    fill: "#4C019A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0896 20.623H19.2098V48.6H19.0896V20.623Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1699 20.623H19.2895V48.6H19.1699V20.623Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2496 20.623H19.3692V48.6H19.2496V20.623Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3293 20.623H19.449V48.6H19.3293V20.623Z",
    fill: "#4B0198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4093 20.623H19.5289V48.6H19.4093V20.623Z",
    fill: "#4B0198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.489 20.623H19.6086V48.6H19.489V20.623Z",
    fill: "#4B0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5687 20.623H19.6884V48.6H19.5687V20.623Z",
    fill: "#4B0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6485 20.623H19.7687V48.6H19.6485V20.623Z",
    fill: "#4A0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7282 20.623H19.8484V48.6H19.7282V20.623Z",
    fill: "#4A0196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8086 20.623H19.9283V48.6H19.8086V20.623Z",
    fill: "#4A0196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8884 20.623H20.008V48.6H19.8884V20.623Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9681 20.623H20.0877V48.6H19.9681V20.623Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0478 20.623H20.1675V48.6H20.0478V20.623Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1276 20.623H20.2472V48.6H20.1276V20.623Z",
    fill: "#490194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2073 20.623H20.327V48.6H20.2073V20.623Z",
    fill: "#480194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.287 20.623H20.4073V48.6H20.287V20.623Z",
    fill: "#480193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3668 20.623H20.487V48.6H20.3668V20.623Z",
    fill: "#480193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4472 20.623H20.5669V48.6H20.4472V20.623Z",
    fill: "#470193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.527 20.623H20.6466V48.6H20.527V20.623Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6067 20.623H20.7263V48.6H20.6067V20.623Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6864 20.623H20.8061V48.6H20.6864V20.623Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7662 20.623H20.8858V48.6H20.7662V20.623Z",
    fill: "#460191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8461 20.623H20.9663V48.6H20.8461V20.623Z",
    fill: "#460191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9264 20.623H21.046V48.6H20.9264V20.623Z",
    fill: "#460190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0061 20.623H21.1257V48.6H21.0061V20.623Z",
    fill: "#450190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0858 20.623H21.2055V48.6H21.0858V20.623Z",
    fill: "#450190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1656 20.623H21.2852V48.6H21.1656V20.623Z",
    fill: "#45018F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2455 20.623H21.3651V48.6H21.2455V20.623Z",
    fill: "#45018F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3252 20.623H21.4454V48.6H21.3252V20.623Z",
    fill: "#44018E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4049 20.623H21.5252V48.6H21.4049V20.623Z",
    fill: "#44018E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4852 20.623H21.6049V48.6H21.4852V20.623Z",
    fill: "#3D008C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2582_57976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 20,
    width: 22,
    height: 29
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3244 20.5005C35.2265 20.6737 27.866 26.4336 24.3358 32.4632C20.0127 39.8474 22.5638 42.5747 21.6585 48.8536C22.29 48.7584 22.2299 48.7334 22.8513 48.0715C23.2341 47.6644 23.3751 47.5513 23.8239 47.1936L25.8607 45.5264C27.1577 44.5663 28.9255 43.602 30.5832 42.8372C36.4556 40.1272 39.7918 40.601 42.1774 39.7778C42.7072 37.9903 42.2935 23.7141 42.3238 20.5005H42.3244Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2582_57976)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5772 20.5005H21.6987V48.8536H21.5772V20.5005Z",
    fill: "#44018E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6582 20.5005H21.7803V48.8536H21.6582V20.5005Z",
    fill: "#3D008C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7392 20.5005H21.8612V48.8536H21.7392V20.5005Z",
    fill: "#3D008C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8208 20.5005H21.9428V48.8536H21.8208V20.5005Z",
    fill: "#3E008D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9016 20.5005H22.0236V48.8536H21.9016V20.5005Z",
    fill: "#3E008D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9831 20.5005H22.1045V48.8536H21.9831V20.5005Z",
    fill: "#3F008E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0641 20.5005H22.1861V48.8536H22.0641V20.5005Z",
    fill: "#3F008E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1456 20.5005H22.267V48.8536H22.1456V20.5005Z",
    fill: "#3F008F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2266 20.5005H22.3486V48.8536H22.2266V20.5005Z",
    fill: "#40008F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3081 20.5005H22.4296V48.8536H22.3081V20.5005Z",
    fill: "#400090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3891 20.5005H22.5112V48.8536H22.3891V20.5005Z",
    fill: "#410090"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4707 20.5005H22.5921V48.8536H22.4707V20.5005Z",
    fill: "#410091"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5517 20.5005H22.6737V48.8536H22.5517V20.5005Z",
    fill: "#410091"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6327 20.5005H22.7547V48.8536H22.6327V20.5005Z",
    fill: "#420092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7142 20.5005H22.8362V48.8536H22.7142V20.5005Z",
    fill: "#420092"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.795 20.5005H22.917V48.8536H22.795V20.5005Z",
    fill: "#420093"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8765 20.5005H22.9979V48.8536H22.8765V20.5005Z",
    fill: "#430093"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9575 20.5005H23.0795V48.8536H22.9575V20.5005Z",
    fill: "#430094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.039 20.5005H23.1605V48.8536H23.039V20.5005Z",
    fill: "#440094"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.12 20.5005H23.2421V48.8536H23.12V20.5005Z",
    fill: "#440095"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2016 20.5005H23.323V48.8536H23.2016V20.5005Z",
    fill: "#440095"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2826 20.5005H23.4046V48.8536H23.2826V20.5005Z",
    fill: "#450096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3641 20.5005H23.4855V48.8536H23.3641V20.5005Z",
    fill: "#450096"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4451 20.5005H23.5665V48.8536H23.4451V20.5005Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5261 20.5005H23.6481V48.8536H23.5261V20.5005Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6076 20.5005H23.729V48.8536H23.6076V20.5005Z",
    fill: "#460097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6884 20.5005H23.8104V48.8536H23.6884V20.5005Z",
    fill: "#470098"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7699 20.5005H23.8914V48.8536H23.7699V20.5005Z",
    fill: "#470098"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8509 20.5005H23.973V48.8536H23.8509V20.5005Z",
    fill: "#480099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9319 20.5005H24.054V48.8536H23.9319V20.5005Z",
    fill: "#480099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0135 20.5005H24.1355V48.8536H24.0135V20.5005Z",
    fill: "#48009A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0945 20.5005H24.2165V48.8536H24.0945V20.5005Z",
    fill: "#49009A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.176 20.5005H24.298V48.8536H24.176V20.5005Z",
    fill: "#49009B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.257 20.5005H24.379V48.8536H24.257V20.5005Z",
    fill: "#4A009B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3385 20.5005H24.4599V48.8536H24.3385V20.5005Z",
    fill: "#4A009C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4195 20.5005H24.5415V48.8536H24.4195V20.5005Z",
    fill: "#4A009C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.501 20.5005H24.6224V48.8536H24.501V20.5005Z",
    fill: "#4B009D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5818 20.5005H24.7039V48.8536H24.5818V20.5005Z",
    fill: "#4B009D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6634 20.5005H24.7848V48.8536H24.6634V20.5005Z",
    fill: "#4C009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7444 20.5005H24.8664V48.8536H24.7444V20.5005Z",
    fill: "#4C009E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8253 20.5005H24.9474V48.8536H24.8253V20.5005Z",
    fill: "#4C009F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9069 20.5005H25.0289V48.8536H24.9069V20.5005Z",
    fill: "#4D009F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9879 20.5005H25.1099V48.8536H24.9879V20.5005Z",
    fill: "#4D00A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0694 20.5005H25.1914V48.8536H25.0694V20.5005Z",
    fill: "#4D00A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1504 20.5005H25.2724V48.8536H25.1504V20.5005Z",
    fill: "#4E00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2319 20.5005H25.3533V48.8536H25.2319V20.5005Z",
    fill: "#4E00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3129 20.5005H25.4349V48.8536H25.3129V20.5005Z",
    fill: "#4F00A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3944 20.5005H25.5159V48.8536H25.3944V20.5005Z",
    fill: "#4F00A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4753 20.5005H25.5973V48.8536H25.4753V20.5005Z",
    fill: "#4F00A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5568 20.5005H25.6782V48.8536H25.5568V20.5005Z",
    fill: "#5000A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6378 20.5005H25.7598V48.8536H25.6378V20.5005Z",
    fill: "#5000A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7188 20.5005H25.8408V48.8536H25.7188V20.5005Z",
    fill: "#5100A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8003 20.5005H25.9223V48.8536H25.8003V20.5005Z",
    fill: "#5100A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8813 20.5005H26.0033V48.8536H25.8813V20.5005Z",
    fill: "#5100A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9628 20.5005H26.0842V48.8536H25.9628V20.5005Z",
    fill: "#5200A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0438 20.5005H26.1658V48.8536H26.0438V20.5005Z",
    fill: "#5200A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1253 20.5005H26.2468V48.8536H26.1253V20.5005Z",
    fill: "#5300A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2063 20.5005H26.3284V48.8536H26.2063V20.5005Z",
    fill: "#5300A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2871 20.5005H26.4092V48.8536H26.2871V20.5005Z",
    fill: "#5300A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3687 20.5005H26.4907V48.8536H26.3687V20.5005Z",
    fill: "#5400A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4502 20.5005H26.5716V48.8536H26.4502V20.5005Z",
    fill: "#5400A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5312 20.5005H26.6526V48.8536H26.5312V20.5005Z",
    fill: "#5500A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6122 20.5005H26.7342V48.8536H26.6122V20.5005Z",
    fill: "#5500A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6937 20.5005H26.8151V48.8536H26.6937V20.5005Z",
    fill: "#5500AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7747 20.5005H26.8967V48.8536H26.7747V20.5005Z",
    fill: "#5600AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8562 20.5005H26.9777V48.8536H26.8562V20.5005Z",
    fill: "#5600AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9372 20.5005H27.0593V48.8536H26.9372V20.5005Z",
    fill: "#5600AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.018 20.5005H27.1401V48.8536H27.018V20.5005Z",
    fill: "#5700AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0998 20.5005H27.2218V48.8536H27.0998V20.5005Z",
    fill: "#5700AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1806 20.5005H27.3026V48.8536H27.1806V20.5005Z",
    fill: "#5800AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2621 20.5005H27.3841V48.8536H27.2621V20.5005Z",
    fill: "#5800AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3431 20.5005H27.4651V48.8536H27.3431V20.5005Z",
    fill: "#5800AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4246 20.5005H27.546V48.8536H27.4246V20.5005Z",
    fill: "#5900AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5056 20.5005H27.6276V48.8536H27.5056V20.5005Z",
    fill: "#5900AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5871 20.5005H27.7086V48.8536H27.5871V20.5005Z",
    fill: "#5A00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6681 20.5005H27.7902V48.8536H27.6681V20.5005Z",
    fill: "#5A00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7497 20.5005H27.8711V48.8536H27.7497V20.5005Z",
    fill: "#5A00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8307 20.5005H27.9527V48.8536H27.8307V20.5005Z",
    fill: "#5B00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9115 20.5005H28.0335V48.8536H27.9115V20.5005Z",
    fill: "#5B00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9932 20.5005H28.1152V48.8536H27.9932V20.5005Z",
    fill: "#5C00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.074 20.5005H28.196V48.8536H28.074V20.5005Z",
    fill: "#5C00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1555 20.5005H28.2775V48.8536H28.1555V20.5005Z",
    fill: "#5C00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2365 20.5005H28.3585V48.8536H28.2365V20.5005Z",
    fill: "#5D00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.318 20.5005H28.4395V48.8536H28.318V20.5005Z",
    fill: "#5D00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.399 20.5005H28.5211V48.8536H28.399V20.5005Z",
    fill: "#5E00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4806 20.5005H28.602V48.8536H28.4806V20.5005Z",
    fill: "#5E00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5616 20.5005H28.6836V48.8536H28.5616V20.5005Z",
    fill: "#5E00B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6431 20.5005H28.7645V48.8536H28.6431V20.5005Z",
    fill: "#5F00B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7241 20.5005H28.8461V48.8536H28.7241V20.5005Z",
    fill: "#5F00B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8049 20.5005H28.9269V48.8536H28.8049V20.5005Z",
    fill: "#6000B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8866 20.5005H29.0086V48.8536H28.8866V20.5005Z",
    fill: "#6000B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9674 20.5005H29.0894V48.8536H28.9674V20.5005Z",
    fill: "#6000B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0489 20.5005H29.171V48.8536H29.0489V20.5005Z",
    fill: "#6100B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1299 20.5005H29.2519V48.8536H29.1299V20.5005Z",
    fill: "#6100B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2115 20.5005H29.3329V48.8536H29.2115V20.5005Z",
    fill: "#6100B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2924 20.5005H29.4145V48.8536H29.2924V20.5005Z",
    fill: "#6200B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3734 20.5005H29.4955V48.8536H29.3734V20.5005Z",
    fill: "#6200B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.455 20.5005H29.577V48.8536H29.455V20.5005Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.536 20.5005H29.658V48.8536H29.536V20.5005Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6175 20.5005H29.7389V48.8536H29.6175V20.5005Z",
    fill: "#6300BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6983 20.5005H29.8203V48.8536H29.6983V20.5005Z",
    fill: "#6400BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7798 20.5005H29.9013V48.8536H29.7798V20.5005Z",
    fill: "#6400BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8608 20.5005H29.9828V48.8536H29.8608V20.5005Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9424 20.5005H30.0638V48.8536H29.9424V20.5005Z",
    fill: "#6500BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0233 20.5005H30.1454V48.8536H30.0233V20.5005Z",
    fill: "#6500BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1049 20.5005H30.2263V48.8536H30.1049V20.5005Z",
    fill: "#6600BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1859 20.5005H30.3079V48.8536H30.1859V20.5005Z",
    fill: "#6600BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2669 20.5005H30.3889V48.8536H30.2669V20.5005Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3484 20.5005H30.4704V48.8536H30.3484V20.5005Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4294 20.5005H30.5514V48.8536H30.4294V20.5005Z",
    fill: "#6700C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5109 20.5005H30.6323V48.8536H30.5109V20.5005Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5917 20.5005H30.7138V48.8536H30.5917V20.5005Z",
    fill: "#6800C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6733 20.5005H30.7947V48.8536H30.6733V20.5005Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7543 20.5005H30.8763V48.8536H30.7543V20.5005Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8358 20.5005H30.9572V48.8536H30.8358V20.5005Z",
    fill: "#6900C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9168 20.5005H31.0388V48.8536H30.9168V20.5005Z",
    fill: "#6A00C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9983 20.5005H31.1197V48.8536H30.9983V20.5005Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0793 20.5005H31.2013V48.8536H31.0793V20.5005Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1603 20.5005H31.2823V48.8536H31.1603V20.5005Z",
    fill: "#6B00C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2418 20.5005H31.3638V48.8536H31.2418V20.5005Z",
    fill: "#6B00C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3228 20.5005H31.4448V48.8536H31.3228V20.5005Z",
    fill: "#6B00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4043 20.5005H31.5258V48.8536H31.4043V20.5005Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4852 20.5005H31.6072V48.8536H31.4852V20.5005Z",
    fill: "#6A00C3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5667 20.5005H31.6881V48.8536H31.5667V20.5005Z",
    fill: "#6A00C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6477 20.5005H31.7697V48.8536H31.6477V20.5005Z",
    fill: "#6900C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7292 20.5005H31.8506V48.8536H31.7292V20.5005Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8102 20.5005H31.9322V48.8536H31.8102V20.5005Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8912 20.5005H32.0132V48.8536H31.8912V20.5005Z",
    fill: "#6900C1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9727 20.5005H32.0941V48.8536H31.9727V20.5005Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0537 20.5005H32.1757V48.8536H32.0537V20.5005Z",
    fill: "#6800C0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1352 20.5005H32.2567V48.8536H32.1352V20.5005Z",
    fill: "#6800BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2162 20.5005H32.3383V48.8536H32.2162V20.5005Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2978 20.5005H32.4192V48.8536H32.2978V20.5005Z",
    fill: "#6700BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3786 20.5005H32.5006V48.8536H32.3786V20.5005Z",
    fill: "#6700BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4596 20.5005H32.5816V48.8536H32.4596V20.5005Z",
    fill: "#6700BE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5411 20.5005H32.6631V48.8536H32.5411V20.5005Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6221 20.5005H32.7441V48.8536H32.6221V20.5005Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7036 20.5005H32.8256V48.8536H32.7036V20.5005Z",
    fill: "#6600BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7846 20.5005H32.9066V48.8536H32.7846V20.5005Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8661 20.5005H32.9876V48.8536H32.8661V20.5005Z",
    fill: "#6500BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9471 20.5005H33.0691V48.8536H32.9471V20.5005Z",
    fill: "#6500BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0287 20.5005H33.1501V48.8536H33.0287V20.5005Z",
    fill: "#6500BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1096 20.5005H33.2317V48.8536H33.1096V20.5005Z",
    fill: "#6400BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1912 20.5005H33.3126V48.8536H33.1912V20.5005Z",
    fill: "#6400BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.272 20.5005H33.394V48.8536H33.272V20.5005Z",
    fill: "#6400BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.353 20.5005H33.475V48.8536H33.353V20.5005Z",
    fill: "#6300BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4345 20.5005H33.5565V48.8536H33.4345V20.5005Z",
    fill: "#6300B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5155 20.5005H33.6375V48.8536H33.5155V20.5005Z",
    fill: "#6300B9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.597 20.5005H33.7185V48.8536H33.597V20.5005Z",
    fill: "#6300B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.678 20.5005H33.8V48.8536H33.678V20.5005Z",
    fill: "#6200B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7596 20.5005H33.881V48.8536H33.7596V20.5005Z",
    fill: "#6200B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8405 20.5005H33.9626V48.8536H33.8405V20.5005Z",
    fill: "#6200B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9221 20.5005H34.0435V48.8536H33.9221V20.5005Z",
    fill: "#6100B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0031 20.5005H34.1251V48.8536H34.0031V20.5005Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0846 20.5005H34.206V48.8536H34.0846V20.5005Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1654 20.5005H34.2874V48.8536H34.1654V20.5005Z",
    fill: "#6100B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2464 20.5005H34.3684V48.8536H34.2464V20.5005Z",
    fill: "#6000B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3279 20.5005H34.45V48.8536H34.3279V20.5005Z",
    fill: "#6000B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4089 20.5005H34.5309V48.8536H34.4089V20.5005Z",
    fill: "#6000B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4905 20.5005H34.6119V48.8536H34.4905V20.5005Z",
    fill: "#5F00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5714 20.5005H34.6935V48.8536H34.5714V20.5005Z",
    fill: "#5F00B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.653 20.5005H34.7744V48.8536H34.653V20.5005Z",
    fill: "#5F00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.734 20.5005H34.856V48.8536H34.734V20.5005Z",
    fill: "#5F00B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8155 20.5005H34.9369V48.8536H34.8155V20.5005Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8965 20.5005H35.0185V48.8536H34.8965V20.5005Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.978 20.5005H35.0995V48.8536H34.978V20.5005Z",
    fill: "#5E00B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0588 20.5005H35.1803V48.8536H35.0588V20.5005Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1398 20.5005H35.2619V48.8536H35.1398V20.5005Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2214 20.5005H35.3428V48.8536H35.2214V20.5005Z",
    fill: "#5D00B1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3024 20.5005H35.4244V48.8536H35.3024V20.5005Z",
    fill: "#5D00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3839 20.5005H35.5053V48.8536H35.3839V20.5005Z",
    fill: "#5C00B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4649 20.5005H35.5869V48.8536H35.4649V20.5005Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5459 20.5005H35.6679V48.8536H35.5459V20.5005Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6274 20.5005H35.7494V48.8536H35.6274V20.5005Z",
    fill: "#5C00AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7082 20.5005H35.8302V48.8536H35.7082V20.5005Z",
    fill: "#5B00AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7899 20.5005H35.9119V48.8536H35.7899V20.5005Z",
    fill: "#5B00AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8707 20.5005H35.9927V48.8536H35.8707V20.5005Z",
    fill: "#5B00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9523 20.5005H36.0737V48.8536H35.9523V20.5005Z",
    fill: "#5A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0332 20.5005H36.1553V48.8536H36.0332V20.5005Z",
    fill: "#5A00AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1148 20.5005H36.2362V48.8536H36.1148V20.5005Z",
    fill: "#5A00AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1958 20.5005H36.3178V48.8536H36.1958V20.5005Z",
    fill: "#5A00AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2773 20.5005H36.3987V48.8536H36.2773V20.5005Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3583 20.5005H36.4803V48.8536H36.3583V20.5005Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4393 20.5005H36.5613V48.8536H36.4393V20.5005Z",
    fill: "#5900AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5208 20.5005H36.6428V48.8536H36.5208V20.5005Z",
    fill: "#5800AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6016 20.5005H36.7236V48.8536H36.6016V20.5005Z",
    fill: "#5800AA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6833 20.5005H36.8054V48.8536H36.6833V20.5005Z",
    fill: "#5800A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7641 20.5005H36.8862V48.8536H36.7641V20.5005Z",
    fill: "#5800A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8457 20.5005H36.9671V48.8536H36.8457V20.5005Z",
    fill: "#5701A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9267 20.5005H37.0487V48.8536H36.9267V20.5005Z",
    fill: "#5701A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0082 20.5005H37.1296V48.8536H37.0082V20.5005Z",
    fill: "#5701A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0892 20.5005H37.2112V48.8536H37.0892V20.5005Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1707 20.5005H37.2921V48.8536H37.1707V20.5005Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2517 20.5005H37.3737V48.8536H37.2517V20.5005Z",
    fill: "#5601A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3327 20.5005H37.4547V48.8536H37.3327V20.5005Z",
    fill: "#5601A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4142 20.5005H37.5362V48.8536H37.4142V20.5005Z",
    fill: "#5501A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.495 20.5005H37.6171V48.8536H37.495V20.5005Z",
    fill: "#5501A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5768 20.5005H37.6982V48.8536H37.5768V20.5005Z",
    fill: "#5501A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6576 20.5005H37.7796V48.8536H37.6576V20.5005Z",
    fill: "#5401A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7391 20.5005H37.8605V48.8536H37.7391V20.5005Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8201 20.5005H37.9421V48.8536H37.8201V20.5005Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9011 20.5005H38.0231V48.8536H37.9011V20.5005Z",
    fill: "#5401A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9826 20.5005H38.1046V48.8536H37.9826V20.5005Z",
    fill: "#5301A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0636 20.5005H38.1856V48.8536H38.0636V20.5005Z",
    fill: "#5301A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1451 20.5005H38.2665V48.8536H38.1451V20.5005Z",
    fill: "#5301A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2261 20.5005H38.3481V48.8536H38.2261V20.5005Z",
    fill: "#5201A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3076 20.5005H38.4291V48.8536H38.3076V20.5005Z",
    fill: "#5201A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3885 20.5005H38.5105V48.8536H38.3885V20.5005Z",
    fill: "#5201A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4702 20.5005H38.5916V48.8536H38.4702V20.5005Z",
    fill: "#5201A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.551 20.5005H38.673V48.8536H38.551V20.5005Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6325 20.5005H38.7539V48.8536H38.6325V20.5005Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7135 20.5005H38.8355V48.8536H38.7135V20.5005Z",
    fill: "#5101A0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7945 20.5005H38.9165V48.8536H38.7945V20.5005Z",
    fill: "#50019F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.876 20.5005H38.9981V48.8536H38.876V20.5005Z",
    fill: "#50019F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.957 20.5005H39.079V48.8536H38.957V20.5005Z",
    fill: "#50019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0386 20.5005H39.16V48.8536H39.0386V20.5005Z",
    fill: "#50019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1195 20.5005H39.2416V48.8536H39.1195V20.5005Z",
    fill: "#4F019E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2011 20.5005H39.3225V48.8536H39.2011V20.5005Z",
    fill: "#4F019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2819 20.5005H39.4039V48.8536H39.2819V20.5005Z",
    fill: "#4F019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3636 20.5005H39.485V48.8536H39.3636V20.5005Z",
    fill: "#4E019D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4444 20.5005H39.5664V48.8536H39.4444V20.5005Z",
    fill: "#4E019C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5254 20.5005H39.6474V48.8536H39.5254V20.5005Z",
    fill: "#4E019C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6069 20.5005H39.729V48.8536H39.6069V20.5005Z",
    fill: "#4E019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6879 20.5005H39.8099V48.8536H39.6879V20.5005Z",
    fill: "#4D019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7695 20.5005H39.8915V48.8536H39.7695V20.5005Z",
    fill: "#4D019B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8504 20.5005H39.9725V48.8536H39.8504V20.5005Z",
    fill: "#4D019A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.932 20.5005H40.0534V48.8536H39.932V20.5005Z",
    fill: "#4C019A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.013 20.5005H40.135V48.8536H40.013V20.5005Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0945 20.5005H40.2159V48.8536H40.0945V20.5005Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1753 20.5005H40.2973V48.8536H40.1753V20.5005Z",
    fill: "#4C0199"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.257 20.5005H40.3784V48.8536H40.257V20.5005Z",
    fill: "#4B0198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3378 20.5005H40.4599V48.8536H40.3378V20.5005Z",
    fill: "#4B0198"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4188 20.5005H40.5408V48.8536H40.4188V20.5005Z",
    fill: "#4B0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5004 20.5005H40.6224V48.8536H40.5004V20.5005Z",
    fill: "#4B0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5813 20.5005H40.7034V48.8536H40.5813V20.5005Z",
    fill: "#4A0197"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6629 20.5005H40.7849V48.8536H40.6629V20.5005Z",
    fill: "#4A0196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7439 20.5005H40.8659V48.8536H40.7439V20.5005Z",
    fill: "#4A0196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8254 20.5005H40.9468V48.8536H40.8254V20.5005Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9064 20.5005H41.0284V48.8536H40.9064V20.5005Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9872 20.5005H41.1092V48.8536H40.9872V20.5005Z",
    fill: "#490195"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0687 20.5005H41.1907V48.8536H41.0687V20.5005Z",
    fill: "#490194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1497 20.5005H41.2717V48.8536H41.1497V20.5005Z",
    fill: "#480194"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2312 20.5005H41.3527V48.8536H41.2312V20.5005Z",
    fill: "#480193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3122 20.5005H41.4343V48.8536H41.3122V20.5005Z",
    fill: "#480193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3938 20.5005H41.5152V48.8536H41.3938V20.5005Z",
    fill: "#470193"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4748 20.5005H41.5968V48.8536H41.4748V20.5005Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5563 20.5005H41.6777V48.8536H41.5563V20.5005Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6373 20.5005H41.7593V48.8536H41.6373V20.5005Z",
    fill: "#470192"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7188 20.5005H41.8402V48.8536H41.7188V20.5005Z",
    fill: "#460191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7998 20.5005H41.9218V48.8536H41.7998V20.5005Z",
    fill: "#460191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8806 20.5005H42.0026V48.8536H41.8806V20.5005Z",
    fill: "#460190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9622 20.5005H42.0842V48.8536H41.9622V20.5005Z",
    fill: "#450190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0431 20.5005H42.1652V48.8536H42.0431V20.5005Z",
    fill: "#450190"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1247 20.5005H42.2461V48.8536H42.1247V20.5005Z",
    fill: "#45018F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2057 20.5005H42.3277V48.8536H42.2057V20.5005Z",
    fill: "#45018F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2872 20.5005H42.4086V48.8536H42.2872V20.5005Z",
    fill: "#44018E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3682 20.5005H42.4902V48.8536H42.3682V20.5005Z",
    fill: "#44018E"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.843 9.79594e-05C112.539 0.00843099 113.912 1.3816 113.921 3.07796C113.921 6.18559 108.263 9.26345 108.263 9.26345C108.263 9.26345 102.606 6.14035 102.606 3.07796C102.606 1.37802 103.984 9.79594e-05 105.684 9.79594e-05C106.724 -0.00823507 107.697 0.515555 108.263 1.38814C108.833 0.519722 109.804 -0.00228291 110.843 9.79594e-05Z",
    fill: "#4F46E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5013 48.9141V41.8831H57.239V43.1088H53.9879V44.7841H56.9952V46.0097H53.9879V47.6885H57.2527V48.9141H52.5013ZM60.3365 48.9999C59.9359 48.9999 59.5732 48.8969 59.2482 48.6909C58.9255 48.4826 58.6691 48.1771 58.4792 47.7743C58.2915 47.3692 58.1977 46.8725 58.1977 46.2843C58.1977 45.6801 58.2949 45.1777 58.4895 44.7772C58.684 44.3744 58.9426 44.0734 59.2653 43.8743C59.5903 43.6729 59.9462 43.5722 60.333 43.5722C60.6283 43.5722 60.8743 43.6226 61.0711 43.7233C61.2702 43.8217 61.4305 43.9453 61.5518 44.094C61.6753 44.2405 61.7692 44.3847 61.8333 44.5266H61.8779V41.8831H63.337V48.9141H61.8951V48.0695H61.8333C61.7646 48.216 61.6673 48.3613 61.5415 48.5055C61.4179 48.6474 61.2565 48.7653 61.0574 48.8591C60.8606 48.953 60.6203 48.9999 60.3365 48.9999ZM60.7999 47.8361C61.0357 47.8361 61.2348 47.772 61.3973 47.6438C61.5621 47.5134 61.6879 47.3314 61.7749 47.098C61.8642 46.8645 61.9088 46.591 61.9088 46.2775C61.9088 45.9639 61.8653 45.6916 61.7783 45.4604C61.6914 45.2292 61.5655 45.0507 61.4007 44.9248C61.2359 44.799 61.0357 44.736 60.7999 44.736C60.5596 44.736 60.3571 44.8013 60.1923 44.9317C60.0275 45.0622 59.9027 45.243 59.8181 45.4741C59.7334 45.7053 59.691 45.9731 59.691 46.2775C59.691 46.5842 59.7334 46.8554 59.8181 47.0911C59.905 47.3246 60.0298 47.5077 60.1923 47.6404C60.3571 47.7709 60.5596 47.8361 60.7999 47.8361ZM67.9209 46.6688V43.6409H69.3834V48.9141H67.9793V47.9562H67.9244C67.8054 48.2652 67.6074 48.5135 67.3305 48.7012C67.0558 48.8889 66.7205 48.9827 66.3246 48.9827C65.9721 48.9827 65.662 48.9026 65.3942 48.7424C65.1264 48.5822 64.917 48.3545 64.766 48.0592C64.6172 47.764 64.5417 47.4104 64.5394 46.9984V43.6409H66.0019V46.7375C66.0042 47.0488 66.0877 47.2948 66.2525 47.4756C66.4173 47.6564 66.6381 47.7468 66.9151 47.7468C67.0913 47.7468 67.2561 47.7068 67.4094 47.6267C67.5628 47.5443 67.6864 47.423 67.7802 47.2628C67.8763 47.1025 67.9232 46.9046 67.9209 46.6688ZM72.9358 49.0171C72.3957 49.0171 71.9311 48.9026 71.542 48.6737C71.1552 48.4426 70.8577 48.1222 70.6494 47.7125C70.4434 47.3028 70.3404 46.8313 70.3404 46.2981C70.3404 45.7579 70.4445 45.2842 70.6528 44.8768C70.8634 44.4671 71.162 44.1478 71.5488 43.919C71.9356 43.6878 72.3957 43.5722 72.9289 43.5722C73.389 43.5722 73.7918 43.6558 74.1374 43.8228C74.483 43.9899 74.7565 44.2245 74.9579 44.5266C75.1593 44.8287 75.2703 45.1835 75.2909 45.5909H73.9108C73.8719 45.3277 73.7689 45.1159 73.6018 44.9557C73.437 44.7932 73.2207 44.712 72.953 44.712C72.7264 44.712 72.5284 44.7738 72.359 44.8974C72.192 45.0187 72.0615 45.1961 71.9677 45.4295C71.8738 45.663 71.8269 45.9456 71.8269 46.2775C71.8269 46.6139 71.8727 46.9 71.9642 47.1357C72.0581 47.3715 72.1897 47.5511 72.359 47.6747C72.5284 47.7983 72.7264 47.8601 72.953 47.8601C73.12 47.8601 73.2699 47.8258 73.4027 47.7571C73.5377 47.6885 73.6487 47.5889 73.7357 47.4584C73.825 47.3257 73.8833 47.1666 73.9108 46.9812H75.2909C75.268 47.3841 75.1581 47.7388 74.9613 48.0455C74.7668 48.3499 74.4978 48.5879 74.1545 48.7596C73.8112 48.9312 73.405 49.0171 72.9358 49.0171ZM77.7309 49.0136C77.3945 49.0136 77.0947 48.9553 76.8315 48.8385C76.5683 48.7195 76.36 48.5444 76.2066 48.3133C76.0556 48.0798 75.9801 47.7892 75.9801 47.4413C75.9801 47.1483 76.0339 46.9023 76.1414 46.7032C76.249 46.5041 76.3955 46.3438 76.5809 46.2225C76.7662 46.1012 76.9768 46.0097 77.2125 45.9479C77.4506 45.8861 77.7 45.8426 77.9609 45.8174C78.2676 45.7854 78.5148 45.7556 78.7025 45.7282C78.8902 45.6984 79.0263 45.6549 79.111 45.5977C79.1957 45.5405 79.238 45.4558 79.238 45.3437V45.3231C79.238 45.1057 79.1694 44.9374 79.0321 44.8184C78.897 44.6994 78.7048 44.6399 78.4553 44.6399C78.1921 44.6399 77.9827 44.6983 77.8271 44.815C77.6714 44.9294 77.5684 45.0736 77.5181 45.2476L76.1655 45.1377C76.2341 44.8173 76.3691 44.5403 76.5706 44.3069C76.772 44.0712 77.0317 43.8903 77.3499 43.7645C77.6703 43.6363 78.0411 43.5722 78.4622 43.5722C78.7551 43.5722 79.0355 43.6065 79.3033 43.6752C79.5733 43.7439 79.8125 43.8503 80.0208 43.9945C80.2313 44.1387 80.3973 44.3241 80.5186 44.5506C80.6399 44.7749 80.7005 45.0439 80.7005 45.3574V48.9141H79.3136V48.1828H79.2724C79.1877 48.3476 79.0744 48.4929 78.9325 48.6188C78.7906 48.7424 78.6201 48.8397 78.421 48.9106C78.2219 48.9793 77.9918 49.0136 77.7309 49.0136ZM78.1498 48.0043C78.3649 48.0043 78.5549 47.962 78.7197 47.8773C78.8844 47.7903 79.0138 47.6736 79.1076 47.5271C79.2014 47.3806 79.2483 47.2147 79.2483 47.0293V46.4697C79.2026 46.4995 79.1396 46.5269 79.0595 46.5521C78.9817 46.575 78.8936 46.5967 78.7952 46.6173C78.6968 46.6357 78.5984 46.6528 78.4999 46.6688C78.4015 46.6826 78.3123 46.6952 78.2322 46.7066C78.0605 46.7318 77.9106 46.7718 77.7824 46.8268C77.6543 46.8817 77.5547 46.9561 77.4837 47.0499C77.4128 47.1415 77.3773 47.2559 77.3773 47.3932C77.3773 47.5923 77.4494 47.7445 77.5936 47.8498C77.7401 47.9528 77.9255 48.0043 78.1498 48.0043ZM84.64 43.6409V44.7395H81.4644V43.6409H84.64ZM82.1853 42.3775H83.6478V47.2937C83.6478 47.4287 83.6684 47.534 83.7096 47.6095C83.7508 47.6827 83.808 47.7342 83.8813 47.764C83.9568 47.7937 84.0438 47.8086 84.1422 47.8086C84.2108 47.8086 84.2795 47.8029 84.3482 47.7915C84.4168 47.7777 84.4695 47.7674 84.5061 47.7606L84.7361 48.8488C84.6629 48.8717 84.5599 48.898 84.4271 48.9278C84.2944 48.9598 84.133 48.9793 83.9431 48.9862C83.5906 48.9999 83.2816 48.953 83.0161 48.8454C82.7529 48.7378 82.5481 48.5708 82.4016 48.3442C82.2551 48.1176 82.183 47.8315 82.1853 47.4859V42.3775ZM85.5926 48.9141V43.6409H87.0551V48.9141H85.5926ZM86.3273 42.9611C86.1099 42.9611 85.9234 42.889 85.7677 42.7448C85.6144 42.5984 85.5377 42.4233 85.5377 42.2196C85.5377 42.0182 85.6144 41.8454 85.7677 41.7012C85.9234 41.5547 86.1099 41.4815 86.3273 41.4815C86.5447 41.4815 86.7301 41.5547 86.8835 41.7012C87.0391 41.8454 87.1169 42.0182 87.1169 42.2196C87.1169 42.4233 87.0391 42.5984 86.8835 42.7448C86.7301 42.889 86.5447 42.9611 86.3273 42.9611ZM90.6092 49.0171C90.0759 49.0171 89.6148 48.9038 89.2257 48.6772C88.8389 48.4483 88.5402 48.1302 88.3297 47.7228C88.1191 47.3131 88.0138 46.8382 88.0138 46.2981C88.0138 45.7534 88.1191 45.2773 88.3297 44.8699C88.5402 44.4602 88.8389 44.1421 89.2257 43.9155C89.6148 43.6867 90.0759 43.5722 90.6092 43.5722C91.1425 43.5722 91.6025 43.6867 91.9893 43.9155C92.3784 44.1421 92.6782 44.4602 92.8888 44.8699C93.0993 45.2773 93.2046 45.7534 93.2046 46.2981C93.2046 46.8382 93.0993 47.3131 92.8888 47.7228C92.6782 48.1302 92.3784 48.4483 91.9893 48.6772C91.6025 48.9038 91.1425 49.0171 90.6092 49.0171ZM90.6161 47.8841C90.8587 47.8841 91.0612 47.8155 91.2237 47.6782C91.3862 47.5385 91.5087 47.3486 91.5911 47.1083C91.6757 46.868 91.7181 46.5945 91.7181 46.2878C91.7181 45.9811 91.6757 45.7076 91.5911 45.4673C91.5087 45.227 91.3862 45.037 91.2237 44.8974C91.0612 44.7578 90.8587 44.688 90.6161 44.688C90.3712 44.688 90.1652 44.7578 89.9981 44.8974C89.8333 45.037 89.7086 45.227 89.6239 45.4673C89.5415 45.7076 89.5003 45.9811 89.5003 46.2878C89.5003 46.5945 89.5415 46.868 89.6239 47.1083C89.7086 47.3486 89.8333 47.5385 89.9981 47.6782C90.1652 47.8155 90.3712 47.8841 90.6161 47.8841ZM95.618 45.8655V48.9141H94.1556V43.6409H95.5494V44.5712H95.6112C95.7279 44.2645 95.9236 44.0219 96.1982 43.8434C96.4729 43.6626 96.8059 43.5722 97.1973 43.5722C97.5635 43.5722 97.8827 43.6523 98.1551 43.8125C98.4274 43.9727 98.6391 44.2016 98.7902 44.4991C98.9413 44.7944 99.0168 45.1468 99.0168 45.5565V48.9141H97.5543V45.8174C97.5566 45.4947 97.4742 45.243 97.3071 45.0622C97.14 44.8791 96.91 44.7875 96.6171 44.7875C96.4202 44.7875 96.2463 44.8299 96.0952 44.9145C95.9465 44.9992 95.8298 45.1228 95.7451 45.2853C95.6627 45.4455 95.6203 45.6389 95.618 45.8655ZM101.673 49.0136C101.337 49.0136 101.037 48.9553 100.774 48.8385C100.51 48.7195 100.302 48.5444 100.149 48.3133C99.9978 48.0798 99.9223 47.7892 99.9223 47.4413C99.9223 47.1483 99.976 46.9023 100.084 46.7032C100.191 46.5041 100.338 46.3438 100.523 46.2225C100.708 46.1012 100.919 46.0097 101.155 45.9479C101.393 45.8861 101.642 45.8426 101.903 45.8174C102.21 45.7854 102.457 45.7556 102.645 45.7282C102.832 45.6984 102.969 45.6549 103.053 45.5977C103.138 45.5405 103.18 45.4558 103.18 45.3437V45.3231C103.18 45.1057 103.112 44.9374 102.974 44.8184C102.839 44.6994 102.647 44.6399 102.397 44.6399C102.134 44.6399 101.925 44.6983 101.769 44.815C101.614 44.9294 101.511 45.0736 101.46 45.2476L100.108 45.1377C100.176 44.8173 100.311 44.5403 100.513 44.3069C100.714 44.0712 100.974 43.8903 101.292 43.7645C101.612 43.6363 101.983 43.5722 102.404 43.5722C102.697 43.5722 102.978 43.6065 103.245 43.6752C103.516 43.7439 103.755 43.8503 103.963 43.9945C104.174 44.1387 104.339 44.3241 104.461 44.5506C104.582 44.7749 104.643 45.0439 104.643 45.3574V48.9141H103.256V48.1828H103.215C103.13 48.3476 103.017 48.4929 102.875 48.6188C102.733 48.7424 102.562 48.8397 102.363 48.9106C102.164 48.9793 101.934 49.0136 101.673 49.0136ZM102.092 48.0043C102.307 48.0043 102.497 47.962 102.662 47.8773C102.827 47.7903 102.956 47.6736 103.05 47.5271C103.144 47.3806 103.191 47.2147 103.191 47.0293V46.4697C103.145 46.4995 103.082 46.5269 103.002 46.5521C102.924 46.575 102.836 46.5967 102.737 46.6173C102.639 46.6357 102.541 46.6528 102.442 46.6688C102.344 46.6826 102.254 46.6952 102.174 46.7066C102.003 46.7318 101.853 46.7718 101.725 46.8268C101.596 46.8817 101.497 46.9561 101.426 47.0499C101.355 47.1415 101.32 47.2559 101.32 47.3932C101.32 47.5923 101.392 47.7445 101.536 47.8498C101.682 47.9528 101.868 48.0043 102.092 48.0043ZM107.24 41.8831V48.9141H105.777V41.8831H107.24ZM110.676 41.8831H112.51L114.446 46.607H114.528L116.464 41.8831H118.298V48.9141H116.856V44.3378H116.797L114.978 48.8797H113.996L112.177 44.3206H112.118V48.9141H110.676V41.8831ZM121.898 49.0171C121.356 49.0171 120.889 48.9072 120.497 48.6875C120.108 48.4655 119.809 48.1519 119.598 47.7468C119.387 47.3394 119.282 46.8577 119.282 46.3015C119.282 45.7591 119.387 45.283 119.598 44.8733C119.809 44.4637 120.105 44.1444 120.487 43.9155C120.872 43.6867 121.323 43.5722 121.84 43.5722C122.188 43.5722 122.512 43.6283 122.811 43.7404C123.113 43.8503 123.377 44.0162 123.601 44.2382C123.828 44.4602 124.004 44.7395 124.13 45.0759C124.256 45.41 124.318 45.8014 124.318 46.25V46.6517H119.866V45.7453H122.942C122.942 45.5348 122.896 45.3483 122.804 45.1858C122.713 45.0233 122.586 44.8962 122.423 44.8047C122.263 44.7108 122.077 44.6639 121.864 44.6639C121.642 44.6639 121.445 44.7154 121.273 44.8184C121.104 44.9191 120.971 45.0553 120.875 45.227C120.779 45.3963 120.73 45.5851 120.727 45.7934V46.6551C120.727 46.916 120.776 47.1415 120.872 47.3314C120.97 47.5214 121.109 47.6679 121.287 47.7709C121.466 47.8738 121.677 47.9253 121.922 47.9253C122.085 47.9253 122.233 47.9025 122.368 47.8567C122.504 47.8109 122.619 47.7422 122.715 47.6507C122.811 47.5591 122.885 47.447 122.935 47.3143L124.288 47.4035C124.219 47.7285 124.078 48.0123 123.865 48.2549C123.655 48.4952 123.382 48.6829 123.048 48.8179C122.716 48.9507 122.333 49.0171 121.898 49.0171ZM126.735 45.8655V48.9141H125.273V43.6409H126.667V44.5712H126.728C126.845 44.2645 127.041 44.0219 127.316 43.8434C127.59 43.6626 127.923 43.5722 128.315 43.5722C128.681 43.5722 129 43.6523 129.272 43.8125C129.545 43.9727 129.756 44.2016 129.907 44.4991C130.059 44.7944 130.134 45.1468 130.134 45.5565V48.9141H128.672V45.8174C128.674 45.4947 128.591 45.243 128.424 45.0622C128.257 44.8791 128.027 44.7875 127.734 44.7875C127.538 44.7875 127.364 44.8299 127.213 44.9145C127.064 44.9992 126.947 45.1228 126.862 45.2853C126.78 45.4455 126.738 45.6389 126.735 45.8655ZM134.092 43.6409V44.7395H130.916V43.6409H134.092ZM131.637 42.3775H133.099V47.2937C133.099 47.4287 133.12 47.534 133.161 47.6095C133.202 47.6827 133.26 47.7342 133.333 47.764C133.408 47.7937 133.495 47.8086 133.594 47.8086C133.662 47.8086 133.731 47.8029 133.8 47.7915C133.868 47.7777 133.921 47.7674 133.958 47.7606L134.188 48.8488C134.114 48.8717 134.011 48.898 133.879 48.9278C133.746 48.9598 133.585 48.9793 133.395 48.9862C133.042 48.9999 132.733 48.953 132.468 48.8454C132.204 48.7378 132 48.5708 131.853 48.3442C131.707 48.1176 131.635 47.8315 131.637 47.4859V42.3775ZM137.37 49.0171C136.837 49.0171 136.376 48.9038 135.987 48.6772C135.6 48.4483 135.301 48.1302 135.091 47.7228C134.88 47.3131 134.775 46.8382 134.775 46.2981C134.775 45.7534 134.88 45.2773 135.091 44.8699C135.301 44.4602 135.6 44.1421 135.987 43.9155C136.376 43.6867 136.837 43.5722 137.37 43.5722C137.903 43.5722 138.363 43.6867 138.75 43.9155C139.139 44.1421 139.439 44.4602 139.65 44.8699C139.86 45.2773 139.966 45.7534 139.966 46.2981C139.966 46.8382 139.86 47.3131 139.65 47.7228C139.439 48.1302 139.139 48.4483 138.75 48.6772C138.363 48.9038 137.903 49.0171 137.37 49.0171ZM137.377 47.8841C137.62 47.8841 137.822 47.8155 137.985 47.6782C138.147 47.5385 138.27 47.3486 138.352 47.1083C138.437 46.868 138.479 46.5945 138.479 46.2878C138.479 45.9811 138.437 45.7076 138.352 45.4673C138.27 45.227 138.147 45.037 137.985 44.8974C137.822 44.7578 137.62 44.688 137.377 44.688C137.132 44.688 136.926 44.7578 136.759 44.8974C136.594 45.037 136.47 45.227 136.385 45.4673C136.302 45.7076 136.261 45.9811 136.261 46.2878C136.261 46.5945 136.302 46.868 136.385 47.1083C136.47 47.3486 136.594 47.5385 136.759 47.6782C136.926 47.8155 137.132 47.8841 137.377 47.8841ZM140.916 48.9141V43.6409H142.334V44.5609H142.389C142.485 44.2337 142.647 43.9865 142.873 43.8194C143.1 43.65 143.361 43.5653 143.656 43.5653C143.729 43.5653 143.808 43.5699 143.893 43.5791C143.978 43.5882 144.052 43.6008 144.116 43.6168V44.9145C144.047 44.8939 143.952 44.8756 143.831 44.8596C143.71 44.8436 143.599 44.8356 143.498 44.8356C143.283 44.8356 143.091 44.8825 142.921 44.9763C142.754 45.0679 142.622 45.1961 142.523 45.3608C142.427 45.5256 142.379 45.7156 142.379 45.9307V48.9141H140.916Z",
    fill: "#4F46E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.4d2fe8bfa887f71ce56542ab747a61ab.svg";
export { ForwardRef as ReactComponent };